module.exports = __webpack_public_path__ + "media/message.803b23c6.mp3";